import React from 'react';
import '../styles/Navbar.css';

const iconSize = 20;

const AmenityIcon = ({ name }) => {
  const props = { width: iconSize, height: iconSize, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (name) {
    case 'wifi':
      return (
        <svg {...props}><path d="M5 12.55a11 11 0 0 1 14.08 0" /><path d="M1.42 9a16 16 0 0 1 21.16 0" /><path d="M8.53 16.11a6 6 0 0 1 6.95 0" /><line x1="12" y1="20" x2="12.01" y2="20" /></svg>
      );
    case 'tv':
      return (
        <svg {...props}><rect x="2" y="7" width="20" height="15" rx="2" ry="2" /><polyline points="17 2 12 7 7 2" /></svg>
      );
    case 'ac':
      return (
        <svg {...props}><path d="M12 2v4" /><path d="M12 18v4" /><path d="M4.93 4.93l2.83 2.83" /><path d="M16.24 16.24l2.83 2.83" /><path d="M2 12h4" /><path d="M18 12h4" /><path d="M4.93 19.07l2.83-2.83" /><path d="M16.24 7.76l2.83-2.83" /><circle cx="12" cy="12" r="3" /></svg>
      );
    case 'kitchen':
      return (
        <svg {...props}><path d="M3 6h18" /><path d="M3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6" /><path d="M3 10h18" /><path d="M8 10v6" /><path d="M12 10v6" /><path d="M16 10v6" /></svg>
      );
    case 'beach':
      return (
        <svg {...props}><path d="M18 20a2 2 0 0 0 2-2V8" /><path d="M4 20a2 2 0 0 1 2-2V8" /><path d="M2 8h20v12a2 2 0 0 1-2 2" /><path d="M7 8V6a2 2 0 0 1 2-2 2 2 0 0 1 2 2v2" /><path d="M15 8V6a2 2 0 0 1 2-2 2 2 0 0 1 2 2v2" /><path d="M7 12h10" /></svg>
      );
    case 'pool':
      return (
        <svg {...props}><path d="M2 12h20" /><path d="M5 12v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" /><path d="M5 12a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2" /><path d="M9 8l1.5 2" /><path d="M15 8l-1.5 2" /></svg>
      );
    case 'work':
      return (
        <svg {...props}><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>
      );
    case 'parking':
      return (
        <svg {...props}><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><path d="M9 7h4a3 3 0 0 1 0 6H9V7z" /><path d="M9 13h4" /></svg>
      );
    case 'alarm':
      return (
        <svg {...props}><path d="M12 22a3 3 0 0 0 3-3H9a3 3 0 0 0 3 3z" /><path d="M12 2v2" /><path d="M4.93 4.93l1.41 1.41" /><path d="M17.66 6.34l1.41 1.41" /><path d="M2 12h2" /><path d="M20 12h2" /><path d="M6.34 17.66l-1.41 1.41" /><path d="M19.07 4.93l-1.41 1.41" /><path d="M12 8v5l2 2" /></svg>
      );
    case 'smoke':
      return (
        <svg {...props}><path d="M12 22a3 3 0 0 0 3-3H9a3 3 0 0 0 3 3z" /><path d="M12 2v2" /><path d="M4.93 4.93l1.41 1.41" /><path d="M17.66 6.34l1.41 1.41" /><path d="M2 12h2" /><path d="M20 12h2" /><path d="M6.34 17.66l-1.41 1.41" /><path d="M19.07 4.93l-1.41 1.41" /><path d="M12 8v4l2 2" /></svg>
      );
    default:
      return (
        <svg {...props}><circle cx="12" cy="12" r="3" /></svg>
      );
  }
};

const RESIDENCE_ITEMS = [
  { id: 1, icon: 'luxury', title: 'Zebra Suite', desc: 'Signature Naya Villa suite with warm modern interiors and full comfort in Goba.' },
  { id: 2, icon: 'premium', title: 'Lion Suite', desc: 'Refined villa suite with stylish spaces, pool access, and everything for a longer stay.' },
  { id: 3, icon: 'studio', title: 'Tiger Suite', desc: 'Elegant living and kitchen space—perfect for couples or small groups.' },
  { id: 4, icon: 'custom', title: 'Garden Suite', desc: 'Thoughtfully curated suite with calm outdoor access at Naya Villa.' },
  { id: 5, icon: 'family', title: 'Family Villa Stay', desc: 'Extra space for families. Kitchen, parking, and villa amenities for everyone.' },
  { id: 6, icon: 'browse', title: 'Browse All', desc: 'Explore all our residences and find the perfect fit for your trip to Dar es Salaam.' }
];

const RESIDENCE_FEATURED = {
  image: '/assest/images/featured.jpeg',
  overline: 'Naya Villa',
  title: 'Quiet Luxury in Goba',
  headline: 'Where Serenity Meets Style',
  desc: 'Discover thoughtfully designed villa suites on Oysterbay Street, Goba. Book your stay today.',
  linkText: 'Explore residences'
};

const ResidenceIcon = ({ name }) => {
  const p = { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (name) {
    case 'luxury':
      return (<svg {...p}><path d="M3 21h18" /><path d="M5 21V7l8-4v18" /><path d="M19 21V11l-6-4" /><path d="M9 9v.01" /><path d="M9 12v.01" /><path d="M9 15v.01" /></svg>);
    case 'premium':
      return (<svg {...p}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>);
    case 'studio':
      return (<svg {...p}><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><path d="M3 9h18" /><path d="M9 21V9" /></svg>);
    case 'browse':
      return (<svg {...p}><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></svg>);
    case 'custom':
      return (<svg {...p}><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></svg>);
    case 'family':
      return (<svg {...p}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>);
    default:
      return (<svg {...p}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>);
  }
};

const AMENITIES_SECTIONS = [
  {
    title: 'Comfort & connectivity',
    items: [
      { name: 'Wifi', desc: 'High-speed internet for work and streaming.', icon: 'wifi' },
      { name: 'TV', desc: 'Smart TV for entertainment during your stay.', icon: 'tv' },
      { name: 'Air conditioning', desc: 'Climate control for your comfort.', icon: 'ac' },
      { name: 'Kitchen', desc: 'Fully equipped kitchen for self-catering.', icon: 'kitchen' }
    ]
  },
  {
    title: 'Outdoor & leisure',
    items: [
      { name: 'Beach access', desc: 'Steps away from the Indian Ocean.', icon: 'beach' },
      { name: 'Pool', desc: 'Swimming pool in the compound.', icon: 'pool' },
      { name: 'Dedicated workspace', desc: 'Desk and quiet space for remote work.', icon: 'work' }
    ]
  },
  {
    title: 'Safety & convenience',
    items: [
      { name: 'Free parking', desc: 'On-premises parking for guests.', icon: 'parking' },
      { name: 'Carbon monoxide alarm', desc: 'Safety equipment for your peace of mind.', icon: 'alarm' },
      { name: 'Smoke alarm', desc: 'Fire safety devices installed.', icon: 'smoke' }
    ]
  }
];

function Navbar({ onResidenceClick }) {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [amenitiesOpen, setAmenitiesOpen] = React.useState(false);
  const [residenceOpen, setResidenceOpen] = React.useState(false);
  const residenceDropdownRef = React.useRef(null);
  const amenitiesDropdownRef = React.useRef(null);

  React.useEffect(() => {
    if (!isMenuOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMenuOpen]);

  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (residenceDropdownRef.current && !residenceDropdownRef.current.contains(e.target)) {
        setResidenceOpen(false);
      }
      if (amenitiesDropdownRef.current && !amenitiesDropdownRef.current.contains(e.target)) {
        setAmenitiesOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((open) => {
      if (open) {
        setResidenceOpen(false);
        setAmenitiesOpen(false);
      }
      return !open;
    });
  };

  const goToHome = (e) => {
    e.preventDefault();
    window.location.hash = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const closeAmenitiesAndGo = (e) => {
    setAmenitiesOpen(false);
    setIsMenuOpen(false);
  };

  const handleResidenceClick = (e, id) => {
    e.preventDefault();
    setResidenceOpen(false);
    setIsMenuOpen(false);
    window.location.hash = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (onResidenceClick) onResidenceClick(id);
  };

  return (
    <nav className="navbar">
      {isMenuOpen && (
        <button
          type="button"
          className="navbar-backdrop"
          aria-label="Close menu"
          onClick={() => {
            setIsMenuOpen(false);
            setResidenceOpen(false);
            setAmenitiesOpen(false);
          }}
        />
      )}
      <div className="navbar-container">
        <div className="navbar-logo">
          <img
            src="/assest/images/logo32.png"
            alt="Naya Villa"
            className="logo-image"
          />
        </div>

        <button
          type="button"
          className="mobile-menu-btn"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
        >
          <svg className="menu-icon" viewBox="0 0 24 24" aria-hidden="true">
            {isMenuOpen ? (
              <>
                <path d="M5 5l14 14" />
                <path d="M19 5L5 19" />
              </>
            ) : (
              <>
                <path d="M4 7h16" />
                <path d="M4 12h16" />
                <path d="M4 17h16" />
              </>
            )}
          </svg>
        </button>

        <div className={`navbar-center ${isMenuOpen ? 'active' : ''}`}>
          <a href="/" className="nav-link" onClick={goToHome}>Home</a>
          <a href="#about" className="nav-link" onClick={() => setIsMenuOpen(false)}>About</a>
          <div
            className="nav-item-with-dropdown"
            ref={residenceDropdownRef}
          >
            <a
              href="#residence"
              className={`nav-link ${residenceOpen ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); setResidenceOpen(!residenceOpen); setAmenitiesOpen(false); }}
              aria-expanded={residenceOpen}
              aria-haspopup="true"
            >
              Residence
              <span className="nav-chevron" aria-hidden>▼</span>
            </a>
            <div className={`residence-dropdown ${residenceOpen ? 'open' : ''}`}>
              <div className="residence-dropdown-inner">
                <div className="residence-dropdown-grid">
                  {RESIDENCE_ITEMS.map((item) => (
                    <a
                      key={item.id}
                      href="#residence"
                      className="residence-dropdown-item"
                      onClick={(e) => handleResidenceClick(e, item.id)}
                    >
                      <span className="residence-dropdown-item-icon" aria-hidden>
                        <ResidenceIcon name={item.icon} />
                      </span>
                      <div className="residence-dropdown-item-text">
                        <span className="residence-dropdown-item-title">{item.title}</span>
                        <p className="residence-dropdown-item-desc">{item.desc}</p>
                      </div>
                    </a>
                  ))}
                </div>
                <div className="residence-dropdown-featured">
                  <div className="residence-dropdown-featured-card">
                    <div className="residence-dropdown-featured-image-wrap">
                      <img src={RESIDENCE_FEATURED.image} alt="" className="residence-dropdown-featured-image" loading="lazy" decoding="async" />
                      <div className="residence-dropdown-featured-overlay">
                        <span className="residence-dropdown-featured-overline">{RESIDENCE_FEATURED.overline}</span>
                        <span className="residence-dropdown-featured-title">{RESIDENCE_FEATURED.title}</span>
                      </div>
                    </div>
                    <div className="residence-dropdown-featured-caption">
                      <h4 className="residence-dropdown-featured-headline">{RESIDENCE_FEATURED.headline}</h4>
                      <p className="residence-dropdown-featured-desc">{RESIDENCE_FEATURED.desc}</p>
                      <a href="#residence" className="residence-dropdown-featured-link" onClick={(e) => handleResidenceClick(e, 6)}>
                        {RESIDENCE_FEATURED.linkText} →
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="nav-item-with-dropdown"
            ref={amenitiesDropdownRef}
          >
            <a
              href="#amenities"
              className={`nav-link ${amenitiesOpen ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); setAmenitiesOpen(!amenitiesOpen); setResidenceOpen(false); }}
              aria-expanded={amenitiesOpen}
              aria-haspopup="true"
            >
              Amenities
              <span className="nav-chevron" aria-hidden>▼</span>
            </a>
            <div className={`amenities-dropdown ${amenitiesOpen ? 'open' : ''}`}>
              <div className="amenities-dropdown-inner">
                {AMENITIES_SECTIONS.map((section) => (
                  <div key={section.title} className="amenities-dropdown-column">
                    <h3 className="amenities-dropdown-column-title">{section.title}</h3>
                    <ul className="amenities-dropdown-list">
                      {section.items.map((item) => (
                        <li key={item.name}>
                          <a href="#amenities" className="amenities-dropdown-item" onClick={closeAmenitiesAndGo}>
                            <span className="amenities-dropdown-icon" aria-hidden><AmenityIcon name={item.icon} /></span>
                            <div>
                              <span className="amenities-dropdown-name">{item.name}</span>
                              <span className="amenities-dropdown-desc">{item.desc}</span>
                            </div>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <a href="#location" className="nav-link" onClick={() => setIsMenuOpen(false)}>Location</a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
